import ReactDOM from 'react-dom'
import App from './App'

if (process.env.REACT_APP_MOCK === 'TRUE') {
  void (async () => {
    const { worker } = await import('./mocks/browser')

    await worker.start()

    ReactDOM.render(
      <App />,
      document.getElementById('root'),
    )

    worker.printHandlers()
  })()
} else {
  ReactDOM.render(
    <App />,
    document.getElementById('root'),
  )
}